import styled from "styled-components";
import { Box, Flex } from "rebass";
import { FaChevronDown } from "react-icons/fa";
import { useRecoilState, useRecoilValue } from "recoil";
import { Tooltip } from "MVVM/Components/Tooltip";
import {
  RoundedRectangularButton,
  RoundedButton,
} from "MVVM/Components/Button/WithActiveState";
import { ESupportedGames } from "MVVM/@types";
import { GAME_TO_ICON_MAP } from "MVVM/Components/GameSelector";
import { MatchHistoryGame } from "MVVM/State/matchHistory";
import { useGateValue } from "@statsig/react-bindings";
import { useEffect } from "react";
import { useLinkedAccounts } from "MVVM/Hooks/useLinkedAccounts";

const GameSelector = () => {
  const [matchHistoryGame, setMatchHistoryGame] =
    useRecoilState(MatchHistoryGame);
  const { hasSteamLinked, hasRiotLinked, hasEpicLinked } = useLinkedAccounts();

  useEffect(() => {
    if (matchHistoryGame === ESupportedGames.NONE) {
      if (hasSteamLinked) {
        setMatchHistoryGame(ESupportedGames.CS2);
      } else if (hasRiotLinked) {
        setMatchHistoryGame(ESupportedGames.LOL);
      } else if (hasEpicLinked) {
        setMatchHistoryGame(ESupportedGames.FORTNITE);
      }
    }
  }, [
    matchHistoryGame,
    hasRiotLinked,
    hasEpicLinked,
    hasSteamLinked,
    setMatchHistoryGame,
  ]);

  const onGameChange = (game: ESupportedGames) => {
    setMatchHistoryGame(game);
  };

  return (
    <StyledToolTip
      tooltipContent={<TooltipContent onGameChange={onGameChange} />}
    >
      <RoundedButton>
        {GAME_TO_ICON_MAP[matchHistoryGame]}
        <FaChevronDown style={{ marginLeft: 5, flexShrink: 0 }} />
      </RoundedButton>
    </StyledToolTip>
  );
};

const TooltipContent = ({
  onGameChange,
}: {
  onGameChange: (game: ESupportedGames) => void;
}) => {
  const matchHistoryGame = useRecoilValue(MatchHistoryGame);

  const fortniteMatchHistoryEnabled = useGateValue("fortnite_match_history");
  const handleClick = (game: ESupportedGames) => {
    onGameChange(game);
  };

  return (
    <Flex
      flexDirection={"column"}
      style={{ gap: 5, width: "110px", alignSelf: "start" }}
    >
      <RoundedRectangularButton
        mr={2}
        active={matchHistoryGame === ESupportedGames.CS2}
        onClick={() => handleClick(ESupportedGames.CS2)}
      >
        {GAME_TO_ICON_MAP[ESupportedGames.CS2]}
        <Box>CS2</Box>
      </RoundedRectangularButton>
      <RoundedRectangularButton
        active={matchHistoryGame === ESupportedGames.LOL}
        onClick={() => handleClick(ESupportedGames.LOL)}
      >
        {GAME_TO_ICON_MAP[ESupportedGames.LOL]}
        <Box>LoL</Box>
      </RoundedRectangularButton>
      {fortniteMatchHistoryEnabled && (
        <RoundedRectangularButton
          active={matchHistoryGame === ESupportedGames.FORTNITE}
          onClick={() => handleClick(ESupportedGames.FORTNITE)}
        >
          {GAME_TO_ICON_MAP[ESupportedGames.FORTNITE]}
          <Box>Fortnite</Box>
        </RoundedRectangularButton>
      )}
    </Flex>
  );
};

const StyledToolTip = styled(Tooltip)`
  &:hover {
    cursor: pointer;
  }
`;

export { GameSelector };
